import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { RenaultDspGrafico } from 'src/app/models/renault-dsp-dto';
import * as Highcharts from 'highcharts';
import { visibleContentAnimation } from 'src/app/animations';
import { KpisHelper } from '../../kpis/shared/kpis-helper/kpis-helper.component';

@Component({
  selector: 'dsp-statistic',
  templateUrl: './dsp-statistic.component.html',
  animations: [visibleContentAnimation]
})
export class DspStatisticComponent implements OnInit {

  @Input() model: RenaultDspGrafico;

  piesPeriod: any[];
  piesYear: any[];

  funnelsPeriod: any[];
  funnelsYear: any[];

  constructor(private scroller: ViewportScroller, private kpisHelper: KpisHelper) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.model && !changes.model.firstChange) {
      this.loadElements();
    }
  }

  ngOnInit(): void {
    this.loadElements();
  }

  // Método para verificar si debe mostrar la leyenda.
  shouldShowLegend(title: string) {

    var legend = "";

    if (title == 'USO DEL CANAL DE COMUNICACIÓN Y DE RBOOK')
      legend = "*Canal Comunicación Cliente"
    else if (title == 'USO DE MY CHECK-UP' || title == 'OFERTAS ENVIADAS AL CLIENTE')
      legend = "*My Check-up";

    return legend;
  }

  loadElements() {

    Highcharts.setOptions({
      colors: ['#77997a', '#5e81b5', '#b3c6e3', '#db9e60', '#8c8987', '#cfcbc8', '#66d8d0', '#244f35', '#d8c4a0'],
      lang: {
        decimalPoint: ',',
        thousandsSep: '.'
      }
    });

    this.piesPeriod = this.model.Pies.map(pieArray =>
      pieArray.filter(item => item.period === 'PERIOD')).filter((item) => item.length > 0);

    this.piesYear = this.model.Pies.map(pieArray =>
      pieArray.filter(item => item.period === 'YEAR')).filter((item) => item.length > 0);

    this.funnelsPeriod = this.model.Funnels.map(funnelArray =>
      funnelArray.filter(item => item.period === 'PERIOD')).filter((item) => item.length > 0);

    this.funnelsYear = this.model.Funnels.map(funnelArray =>
      funnelArray.filter(item => item.period === 'YEAR')).filter((item) => item.length > 0);

    setTimeout(() => {

      this.piesPeriod.forEach(elem => {

        if (elem.length > 0) {
          var optionsPie: any;

          if (!elem[0].empty) {
            optionsPie = {
              chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie',
                backgroundColor: 'transparent',
                events: {
                  load: function (event) {

                    var total = 0; // get total of data
                    for (var i = 0, len = this.series[0].yData.length; i < len; i++) {
                      total += this.series[0].yData[i];
                    }
                    this.renderer.text(
                      'Total: ' + Highcharts.numberFormat(total, 0),
                      this.plotLeft,
                      this.plotTop
                    ).css({
                      fontWeight: 600
                    }).add()
                  }
                },
              },
              credits: {
                enabled: false
              },
              title: {
                // text: elem[0].title
                text: ''
              },
              tooltip: {
                pointFormat: '<b>{point.percentage:.1f}%</b> ({point.y})'
              },
              accessibility: {
                point: {
                  valueSuffix: '%'
                }
              },
              plotOptions: {
                pie: {
                  allowPointSelect: true,
                  cursor: 'pointer',
                  dataLabels: {
                    enabled: true,
                    format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                  }
                }
              },
              series: [{
                name: 'Roles',
                colorByPoint: true,
                data: []
              }]
            };
            optionsPie.series[0].data = elem;
            Highcharts.chart('piePeriod' + elem[0].title, optionsPie);
          } else {
            optionsPie = {
              title: {
                // text: elem[0].title + " (sin datos)"
                text: ''
              }, credits: {
                enabled: false
              },
              chart: {
                className: 'no-data pie',
                backgroundColor: 'transparent'
              }
            }
            Highcharts.chart('piePeriod' + elem[0].title, optionsPie);
          }
        }

      });

      this.piesYear.forEach(elem => {

        if (elem.length > 0) {
          var optionsPie: any;

          if (!elem[0].empty) {

            optionsPie = {
              chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie',
                backgroundColor: 'transparent',
                events: {
                  load: function (event) {

                    var total = 0; // get total of data
                    for (var i = 0, len = this.series[0].yData.length; i < len; i++) {
                      total += this.series[0].yData[i];
                    }
                    this.renderer.text(
                      'Total: ' + Highcharts.numberFormat(total, 0),
                      this.plotLeft,
                      this.plotTop
                    ).css({
                      fontWeight: 600
                    }).add()
                  }
                }
              },
              credits: {
                enabled: false
              },
              title: {
                // text: elem[0].title
                text: ''
              },
              tooltip: {
                pointFormat: '<b>{point.percentage:.1f}%</b> ({point.y})'
              },
              accessibility: {
                point: {
                  valueSuffix: '%'
                }
              },
              plotOptions: {
                pie: {
                  allowPointSelect: true,
                  cursor: 'pointer',
                  dataLabels: {
                    enabled: true,
                    format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                  }
                }
              },
              series: [{
                name: 'Roles',
                colorByPoint: true,
                data: []
              }]
            };
            optionsPie.series[0].data = elem;
            Highcharts.chart('pieYear' + elem[0].title, optionsPie);
          } else {
            optionsPie = {
              title: {
                // text: 'elem[0].title + " (sin datos)"'
                text: ''
              },
              credits: {
                enabled: false
              },
              chart: {
                className: 'no-data pie',
                backgroundColor: 'transparent'
              }
            }
            Highcharts.chart('pieYear' + elem[0].title, optionsPie);
          }

        }

      });

      this.funnelsPeriod.forEach(elem => {

        if (elem.length > 0) {

          var optionsFunnel: any;

          if (!elem[0].empty) {

            optionsFunnel = {
              chart: {
                type: 'funnel',
                backgroundColor: 'transparent'
              },
              title: {
                // text:  elem[0].title
                text: ''
              },
              credits: {
                enabled: false
              },
              plotOptions: {
                series: {
                  borderColor: '#E4DFD7',
                  borderWidth: 8,
                  dataLabels: {
                    format: '{point.name} {point.y:,.0f}'
                  },
                  center: ['50%', '50%'],
                  width: '60%'
                }
              },
              legend: {
                enabled: false
              },
              series: [{
                name: elem[0].title,
                data: []
              }]
            };

            elem.forEach(elem2 => {

              optionsFunnel.series[0].data.push({
                y: elem2.y,
                name: elem2.name,
                percent: elem2.percent
              });

              optionsFunnel.series[0].dataLabels = {
                format: '{point.name}<br> {y:,0f} {point.percent}'
              };
              Highcharts.chart('funnelPeriod' + elem[0].title, optionsFunnel);

            });

          } else {
            optionsFunnel = {
              title: {
                // text: elem[0].title + " (sin datos)"
                text: ''
              }, credits: {
                enabled: false
              },
              chart: {
                className: 'no-data funnel',
                backgroundColor: 'transparent'
              }
            }
            Highcharts.chart('funnelPeriod' + elem[0].title, optionsFunnel);
          }
        }
      });

      this.funnelsYear.forEach(elem => {

        if (elem.length > 0) {

          var optionsFunnel: any;

          if (!elem[0].empty) {

            optionsFunnel = {
              chart: {
                type: 'funnel',
                backgroundColor: 'transparent'
              },
              title: {
                // text:  elem[0].title
                text: ''
              },
              credits: {
                enabled: false
              },
              plotOptions: {
                series: {
                  borderColor: '#E4DFD7',
                  borderWidth: 8,
                  dataLabels: {
                    format: '<b>{point.name}</b> {point.y:,.0f}'
                  },
                  center: ['50%', '50%'],
                  width: '60%'
                }
              },
              legend: {
                enabled: false
              },
              series: [{
                name: elem[0].title,
                data: []
              }]
            };

            elem.forEach(elem2 => {

              optionsFunnel.series[0].data.push({
                y: elem2.y,
                name: elem2.name,
                percent: elem2.percent
              });

              optionsFunnel.series[0].dataLabels = {
                format: '<b>{point.name}</b><br> {y:,0f} {point.percent}'
              };
              Highcharts.chart('funnelYear' + elem[0].title, optionsFunnel);

            });
          } else {
            optionsFunnel = {
              title: {
                // text: elem[0].title + " (sin datos)"
                text: ''
              }, credits: {
                enabled: false
              },
              chart: {
                className: 'no-data funnel',
                backgroundColor: 'transparent'
              }
            }
            Highcharts.chart('funnelYear' + elem[0].title, optionsFunnel);
          }
        }
      });

    }, 2000);
  }

  scrollToHierarchy(hierarchy) {
    let timeOut = 0;
    const toggleBtn = document.querySelector('.toggle-kpis-inner-navbar') as HTMLElement;
    if (toggleBtn && !toggleBtn.classList.contains('collapsed')) {
      toggleBtn.click();
      timeOut = 300;
    }

    if (document.getElementById(hierarchy) !== null) {
      this.scroller.setOffset([0, this.kpisHelper.setComparativeHeaderTop() as number + 172]);
      setTimeout(() => {
        this.scroller.scrollToAnchor(hierarchy);
      }, timeOut);
    }
  }

  setComparativeHeaderTop() {
    return this.kpisHelper.setComparativeHeaderTop('px');
  }

}
